import { useEffect } from 'react';

import { getFamilyEvents } from '@src/api/event';
import { Spin, message } from 'antd';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import * as XLSX from 'xlsx';

import { closeModal } from '@reduce/modals';

import * as S from './styled';

const actionTypeObj = {
  homepage: '홈페이지 게시',
  mail: '메일 발송',
  sms: '문자 발송',
  funeralFlower: '조화',
  article: '장례용품',
  band: '밴드 게시',
};

const eventTypeObj = {
  wedding: '결혼',
  funeral: '부고',
  opening: '개업',
};

function DownloadFamilyEventModal() {
  const dispatch = useDispatch();

  const close = () => dispatch(closeModal('downloadFamilyEventModal'));

  const downloadFamilyEvent = async () => {
    try {
      const response = await getFamilyEvents({ query: { limit: 3000, page: 1 } });

      if (!response) {
        message.error('다시 시도해주세요.');
        close();
        return;
      }

      const data = response.rows.map(
        ({ title, type, event_groupMembers, createdAt, actionType, date }) => {
          const member = event_groupMembers.find(member => member.requester);

          return {
            구분: eventTypeObj[type],
            경조명: title,
            신청자: member?.kcplaaCsMember?.name ?? '',
            접수일: dayjs(createdAt).format('YYYY.MM.DD'),
            경조사일: dayjs(date).format('YYYY.MM.DD'),
            조치종료: actionType.map(v => `${actionTypeObj[v]}`).join(', ') ?? '',
          };
        },
      );

      const worksheet = XLSX.utils.json_to_sheet(data);

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      XLSX.writeFile(workbook, '경조사 목록.xlsx');

      close();
    } catch (e) {
      close();

      throw e;
    }
  };

  useEffect(() => {
    setTimeout(() => {
      downloadFamilyEvent();
    }, 300);
  }, []);

  return (
    <S.Modal open={true} width={350} centered={true} closeIcon={<></>} footer={[]}>
      <S.ContentWrapper>
        <Spin size='large' />
        <div>경조사 엑셀 파일을 생성하고 있습니다.</div>
      </S.ContentWrapper>
    </S.Modal>
  );
}

export default DownloadFamilyEventModal;
